exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "#settings-header {\n  color: #16448e;\n  padding-left: 10%;\n  padding-top: 2%;\n  font-size: 50px;\n  font-family: Sans-serif; }\n\n.settings-sub-header {\n  color: gray;\n  opacity: 0.5;\n  position: relative;\n  left: 10%;\n  width: 25%; }\n", ""]);

